module.exports = __webpack_public_path__ + "img/IMG_1156_L_Foamcore.654f4a6b.jpg";